module.exports = __webpack_public_path__ + "static/img/logo1.7b19996.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1.svg
// module id = R+dz
// module chunks = 0